import Model from './model';

export default Model.extend( {

    endpoint: 'users/check-login',
    
    defaults: {
        login: '',
    }
    
} );


// WEBPACK FOOTER //
// ./src/js/model/checklogin.js